module.exports = __webpack_public_path__ + "img/ic-arrow-down.255d444a.svg";